import { traitCategories, traitRangesByCategory } from "config/categories";
import { BigNumber } from "ethers";
import { Trait } from "types";

export const getCategoryIndexByName = (category: string) =>
  traitCategories.indexOf(category);

export const getCategoryNameByIndex = (index: number) => traitCategories[index];

export const validateTraitCategory = (tokenId: number, category: string) =>
  tokenId >= traitRangesByCategory[category][0] &&
  tokenId <= traitRangesByCategory[category][1];

export const getTraitCategory = (tokenId: number) =>
  traitCategories.find((category) => validateTraitCategory(tokenId, category))!;

export const getTraitsByCategory = (
  category: string,
  traits: number[],
  excludeTraits?: number[]
) =>
  traits.filter(
    (tokenId) =>
      validateTraitCategory(tokenId, category) &&
      !excludeTraits?.includes(tokenId)
  ) || [];

export const decorateTraitsByCategory = (
  traits: [tokenId: number, name: string][],
  category: string
): Trait[] =>
  traits
    .filter(([tokenId]) => validateTraitCategory(tokenId, category))
    .map(([tokenId, name]) => ({
      tokenId,
      name,
      category,
      honeyConsumptionRequirement: BigNumber.from("0"),
    }));

export const applyTraitChanges = (
  originalTraits: number[],
  newTraits: number[]
): number[] =>
  traitCategories
    .map(
      (category) =>
        newTraits.find((tokenId) => category === getTraitCategory(tokenId)) ||
        originalTraits.find((tokenId) => category === getTraitCategory(tokenId))
    )
    .filter((tokenId) => tokenId !== undefined) as number[];
